export enum UnitTypeLabelEnum {
  Lu = "Lu",
  Bu = "Bu",
  Su = "Su",
}
